"use strict";
var DEFAULT_USER_GROUPS = require('./defaultUserGroups');
var USER_GROUPS = require('./userGroups');
var MODULES = require('./modules');
var USER_GROUP_ROLES = require('./userGroupRoles');
var UserGroupIndex = {
    MODULES: MODULES,
    DEFAULT_USER_GROUPS: DEFAULT_USER_GROUPS,
    USER_GROUPS: USER_GROUPS,
    USER_GROUP_ROLES: USER_GROUP_ROLES
};
module.exports = UserGroupIndex;
